module.exports = __webpack_public_path__ + "static/harrisons-curtains-8b29a099e7a3d836d702c8eb3b485aa6.jpg";